import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"star, favorite, award"} maskId="square-filled-radius-0-stroke-1-IconStar"><path d="M11.9996 0.339844L8.63701 7.37888L0.894531 8.39835L6.55847 13.769L5.13672 21.4386L11.9996 17.7179L18.8625 21.4386L17.4407 13.769L23.1047 8.39835L15.3622 7.37888L11.9996 0.339844Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconStar;
